import { render, staticRenderFns } from "./black-pop.vue?vue&type=template&id=ead7e838&scoped=true"
import script from "./black-pop.vue?vue&type=script&lang=ts"
export * from "./black-pop.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ead7e838",
  null
  
)

export default component.exports